class AddonTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    this.tabButtons = this.querySelectorAll('.addons-help-variants-tab-button');
    this.tabContents = this.querySelectorAll('.addons-help-variants-tab-content');
    this.desktopTabContents = this.querySelectorAll('.addons-help-variants-tab-desktop-content');
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        this.onTabButtonClick(event);
      });
    });
  }

  onTabButtonClick(event) {
    const clickedButton = event.currentTarget;
    const targetTab = clickedButton.dataset.tabButton;

    // Deactivate all buttons and contents
    this.tabButtons.forEach((button) => {
      button.classList.remove('is-active');
    });
    this.tabContents.forEach((content) => {
      content.classList.remove('is-active');
    });
    this.desktopTabContents.forEach((content) => {
      content.classList.remove('is-active');
    });

    // Activate clicked button
    clickedButton.classList.add('is-active');

    // Update mobile content
    const targetContent = this.querySelector(`.addons-help-variants-tab-content[data-tab-content="${targetTab}"]`);
    if (targetContent) {
      targetContent.classList.add('is-active');
    }

    // Update desktop content
    const targetContentDesktop = this.querySelector(`.addons-help-variants-tab-desktop-content[data-tab-content="${targetTab}"]`);
    if (targetContentDesktop) {
      targetContentDesktop.classList.add('is-active');
    }
  }
}

customElements.define('addon-tabs', AddonTabs);